<div fxLayoutGap="20px" class="card card-class">
  <h5 class="card-title"><mat-icon>class</mat-icon>Classes</h5>
    <div class="card-body card-details">

     <!-- <div>
      <div class="profile-card">
        <img src="/assets/exams_img.svg">
        <div class="header">
          <h3>This space is empty!</h3>
          No Class available to display. Use the button below to add one or more classes. 
          We promise you would not see this again after you have successfully added a class.
        </div>  
    </div>   
        <div class="form-group buttons">
          <button class="btn btn-primary next" (click)="openDialogClass()">Add Class</button>
        </div> 
     </div> -->
         
       
     <!-- <div class="form-group buttons">
      <button class="btn btn-primary next" (click)="openDialogClass()">Add Class</button>
    </div> -->
    <button class="btn add-new-user" (click)="openDialogClass()"><i class="fas fa-plus"></i>ADD CLASS</button> 
      <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
        <div fxFlex="20%" *ngFor="let class of classData">
          <mat-card class="mat-elevation-z4" >
            <mat-card-content>
              <div style="display:flex;align-items:center">
                <mat-icon class="center-icon">class</mat-icon>
                <span>{{class.className }}</span> 
              </div>
            </mat-card-content>
            <mat-card-actions>
              <mat-icon (click)="assignedStudents(class)">group</mat-icon>
              <mat-icon (click)="editClass(class)">edit</mat-icon>
              <mat-icon (click)="deleteClass(class)">delete</mat-icon>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
  </div>
</div>
